import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

import {getHideStyles} from '../../utils/utils'

const SpacerBlock = ({
    Height,
    BackgroundColor,
    AddTopBorder,
    TopBorderColor,
    AddBottomBorder,
    BottomBorderColor,
    BorderWidth,
    HideOnDevices
}) => {
    const hideStyles = getHideStyles(HideOnDevices)

    if (hideStyles.doNotLoadComponent) return null

    const borderWidthPx = BorderWidth ? `${BorderWidth}px` : '1px'

    const containerStyles = {
        height: Height ? `${Height}px` : '24px',
        backgroundColor: BackgroundColor || 'transparent',
        borderTop: AddTopBorder ? `${borderWidthPx} solid ${TopBorderColor || '#CCCCCC'}` : 'none',
        borderBottom: AddBottomBorder ? `${borderWidthPx} solid ${BottomBorderColor || '#CCCCCC'}` : 'none'
    }

    return <Box {...containerStyles} {...hideStyles} data-block-type="SpacerBlock" />
}

SpacerBlock.propTypes = {
    Height: PropTypes.number,
    BackgroundColor: PropTypes.string,
    AddTopBorder: PropTypes.bool,
    TopBorderColor: PropTypes.string,
    AddBottomBorder: PropTypes.bool,
    BottomBorderColor: PropTypes.string,
    BorderWidth: PropTypes.number,
    HideOnDevices: PropTypes.string
}

export default SpacerBlock
